
import { Route, Routes } from 'react-router-dom'
import VehicleEmissionsReport from './components/report'

export const ModuleRoutes = () => (
  <Routes>
    <Route path="" element={<VehicleEmissionsReport />} />
  </Routes>
)

export default ModuleRoutes
